import script from "./AnalysisTako.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalysisTako.vue?vue&type=script&setup=true&lang=js"

import "./AnalysisTako.vue?vue&type=style&index=0&id=6aa46e88&scoped=true&lang=css"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6aa46e88"]])

export default __exports__